import React from "react";
import {
  Star, Crown, Rocket, Award, Shield, Zap, Heart, Flame, Gem, Trophy, Sparkles,
  BadgeCheck, Flag, Bookmark, Bell, Key, Coffee, Leaf, Globe, Users, User,
  Briefcase, Building2, Target, TrendingUp, Lightbulb, Medal, Anchor, Compass,
  Diamond, Hexagon, Tag as TagIcon, ThumbsUp, Smile, Sun, Moon, Gift,
} from "lucide-react";
import { fileUrl } from "@/lib/api";

// Curated Lucide set — shared by the renderer and the picker so the public bundle
// only ever pulls these icons (never the whole library).
export const TAG_ICONS = {
  Star, Crown, Rocket, Award, Shield, Zap, Heart, Flame, Gem, Trophy, Sparkles,
  BadgeCheck, Flag, Bookmark, Bell, Key, Coffee, Leaf, Globe, Users, User,
  Briefcase, Building2, Target, TrendingUp, Lightbulb, Medal, Anchor, Compass,
  Diamond, Hexagon, Tag: TagIcon, ThumbsUp, Smile, Sun, Moon, Gift,
};
export const TAG_ICON_NAMES = Object.keys(TAG_ICONS);

/** A single account tag rendered as COLORED TEXT (no pill), with an optional icon. */
export function AccountTagText({ tag, inactive = false, size = "sm", className = "" }) {
  if (!tag) return null;
  const Ico = tag.icon_type === "lucide" ? TAG_ICONS[tag.icon_value] : null;
  const dim = size === "xs" ? "h-3 w-3" : "h-3.5 w-3.5";
  const text = size === "xs" ? "text-xs" : "text-sm";
  return (
    <span
      className={`inline-flex items-center gap-1 font-[600] ${text} ${inactive ? "text-muted-foreground/60" : ""} ${className}`}
      style={inactive ? undefined : { color: tag.color || "#0d9488" }}
      title={inactive ? `${tag.name} (inactive)` : tag.name}
      data-testid={`account-tag-${tag.key || tag.id}`}
    >
      {tag.icon_type === "image" && tag.icon_value && <img src={fileUrl(tag.icon_value)} alt="" className={`${dim} object-contain`} />}
      {tag.icon_type === "emoji" && tag.icon_value && <span aria-hidden className="leading-none">{tag.icon_value}</span>}
      {Ico && <Ico className={dim} />}
      {tag.name}
    </span>
  );
}

/** A row of account tags. `max` caps the count and appends "+N". */
export function AccountTagInline({ tags, max, size = "sm", className = "", testId }) {
  const list = (tags || []).filter(Boolean);
  if (list.length === 0) return null;
  const shown = max ? list.slice(0, max) : list;
  const extra = list.length - shown.length;
  return (
    <div className={`flex flex-wrap items-center gap-x-2 gap-y-0.5 ${className}`} data-testid={testId}>
      {shown.map((t) => <AccountTagText key={t.id} tag={t} size={size} />)}
      {extra > 0 && <span className={`font-[600] text-muted-foreground ${size === "xs" ? "text-xs" : "text-xs"}`}>+{extra}</span>}
    </div>
  );
}

// --- color contrast helper (tags are colored text on a white background) ---
export function contrastVsWhite(hex) {
  try {
    const c = (hex || "").replace("#", "");
    if (c.length < 6) return 21;
    const ch = (i) => parseInt(c.substr(i, 2), 16) / 255;
    const f = (x) => (x <= 0.03928 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4));
    const L = 0.2126 * f(ch(0)) + 0.7152 * f(ch(2)) + 0.0722 * f(ch(4));
    return 1.05 / (L + 0.05);
  } catch { return 21; }
}
